import Router from 'vue-router'
import Layout from '../views/layout/Layout'
// import Vue from 'vue'

// const Vue = window.Vue

// Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      component: Layout
    },
    {
      path: '/dashboard',
      component: Layout,
      name: 'AsyncMQ',
      redirect: '/dashboard/topic',
      meta: { title: 'Async Platform' },
      children: [
        {
          path: 'index',
          name: 'Dashboard',
          component: () => import('../views/dashboard/index.vue'),
          meta: { title: 'Dashboard' }
        },
        {
          path: 'user',
          name: 'User',
          component: () => import('../views/user/index.vue'),
          meta: { title: 'User' }
        },
        {
          path: 'user/:userName',
          name: 'ProducerGroup',
          component: () => import('../views/user/group.vue'),
          meta: { title: 'Producer Group' }
        },
        {
          path: 'topic',
          name: 'Topic',
          component: () => import('../views/topic/index.vue'),
          meta: { title: 'Topic' },
          children: [
            {
              path: 'info',
              name: 'info',
              component: () => import('../views/topic/topicDetail.vue'),
              meta: { title: 'Topic' }
            }
          ]
        },
        {
          path: 'migratingTopic',
          name: 'MigratingTopic',
          component: () => import('../views/topic/migratingTopics.vue'),
          meta: { title: 'MigratingTopic' }
        },
        {
          path: 'collection',
          name: 'Collection',
          component: () => import('../views/collection/index.vue'),
          meta: { title: 'Collection' },
          children: [
            {
              path: 'info',
              name: 'info',
              component: () => import('../views/collection/topicList.vue'),
              meta: { title: 'Topic' }
            }
          ]
        },
        {
          path: 'request',
          name: 'Request',
          component: () => import('../views/request/index.vue'),
          meta: { title: 'Request' }
        },
        {
          path: 'task',
          name: 'Task',
          component: () => import('../views/task/index.vue'),
          meta: { title: 'Task' }
        },
        {
          path: 'longTask',
          name: 'LongTask',
          component: () => import('../views/task/longTask.vue'),
          meta: { title: 'Long Task' }
        },
        {
          path: 'trigger',
          name: 'Batch Trigger',
          component: () => import('../views/trigger/index.vue'),
          meta: { title: 'Trigger' }
        },
        {
          path: 'trigger/:triggerId',
          name: 'Triggers',
          component: () => import('../views/trigger/task.vue'),
          meta: { title: 'TriggerTasks' }
        },
        {
          path: 'job',
          name: 'Job',
          component: () => import('../views/job/index.vue'),
          meta: { title: 'Job' }
        },
        {
          path: 'datacenter',
          name: 'DataCenter',
          component: () => import('../views/datacenter/index.vue'),
          meta: { title: 'DataCenter' }
        },
        {
          path: 'datacenterrouter',
          name: 'DataCenterRouter',
          component: () => import('../views/datacenter/router.vue'),
          meta: { title: 'DataCenterRouter' }
        },
        {
          path: 'group',
          name: 'Group',
          component: () => import('../views/group/index.vue'),
          meta: { title: 'Group' }
        },
        {
          path: 'channel',
          name: 'Cluster',
          component: () => import('../views/channel/index.vue'),
          meta: { title: 'Channel' }
        },
        {
          path: 'sentinel',
          name: 'Sentinel',
          component: () => import('../views/channel/sentinel.vue'),
          meta: { title: 'Sentinel' }
        },
        {
          path: 'channel/describe/:id',
          name: 'Describe',
          component: () => import('../views/channel/describe.vue'),
          meta: { title: 'Describe' },
          children: [
            {
              path: 'topic',
              name: 'Topic Describe',
              component: () => import('../views/channel/topicDescribe.vue'),
              meta: { title: 'Topic Describe' }
            },
            {
              path: 'group',
              name: 'Group Describe',
              component: () => import('../views/channel/groupDescribe.vue'),
              meta: { title: 'Group Describe' }
            }
          ]
        },
        {
          path: 'status',
          name: 'Status',
          component: () => import('../views/status/index.vue'),
          meta: { title: 'Status' }
        },
        {
          path: 'zk',
          name: 'ZK',
          component: () => import('../views/zk/index.vue'),
          meta: { title: 'ZK' }
        },
        {
          path: 'auditlog',
          name: 'AuditLog',
          component: () => import('../views/log/index.vue'),
          meta: { title: 'Audit Log' }
        },
        {
          path: 'client',
          name: 'ClientParam',
          component: () => import('../views/clientparam/index.vue'),
          meta: { title: 'Client Param' }
        },
        {
          path: 'agent',
          name: 'Agent',
          component: () => import('../views/agent/index.vue'),
          meta: { title: 'Agent' }
        },
        {
          path: 'map',
          name: 'Map',
          component: () => import('../views/map/index.vue'),
          meta: { title: 'Map' }
        },
        {
          path: 'monitor',
          name: 'Monitor',
          component: () => import('../views/monitor/index.vue'),
          meta: { title: 'Monitor' }
        },
        {
          path: 'webhook',
          name: 'Webhook',
          component: () => import('../views/webhook/index.vue'),
          meta: { title: 'Webhook' }
        },
        {
          path: 'topicalert',
          name: 'TopicAlert',
          component: () => import('../views/topicAlert/index.vue'),
          meta: { title: 'TopicAlert' }
        },
        {
          path: 'document',
          name: 'Document',
          component: () => import('../views/document/index.vue'),
          meta: { title: 'Document' }
        },
        {
          path: 'clientMap',
          name: 'clientMap',
          component: () => import('../views/clientMap/index.vue'),
          meta: { title: 'Client Map' }
        },
        {
          path: 'monitorManage',
          name: 'monitorManage',
          component: () => import('../views/monitorManagement/index.vue'),
          meta: { title: 'Monitor Management' },
          children: [
            {
              path: 'notificationChannel',
              name: 'notificationChannel',
              component: () => import('../views/monitorManagement/channel.vue'),
              meta: { title: 'notificationChannel' }
            },
            {
              path: 'notificationRule',
              name: 'notificationRule',
              component: () => import('../views/monitorManagement/notificationRule.vue'),
              meta: { title: 'notificationRule' }
            },
            {
              path: 'alarmRule',
              name: 'alarmRule',
              component: () => import('../views/monitorManagement/alarmRule.vue'),
              meta: { title: 'alarmRule' }
            },
            {
              path: 'alarmRecord',
              name: 'alarmRecord',
              component: () => import('../views/monitorManagement/alarmRecord.vue'),
              meta: { title: 'alarmRecord' }
            }
          ]
        },
        {
          path: 'smart',
          name: 'Smart',
          component: () => import('../views/smart/index.vue'),
          meta: { title: 'Smart' }
        },
        {
          path: 'smart/pool/:name/:id',
          name: 'Service Region',
          component: () => import('../views/smart/pool.vue'),
          meta: { title: 'Service Region' }
        },
        {
          path: 'smart/client/:name/:id',
          name: 'Client',
          component: () => import('../views/smart/client.vue'),
          meta: { title: 'Client' }
        },
        {
          path: 'smart/:serviceName/:poolName/client/:serviceId/:poolId',
          name: 'Service Region Client',
          component: () => import('../views/smart/poolClient.vue'),
          meta: { title: 'Service Region Client' }
        },
        {
          path: 'smart/:serviceName/:poolName/application/:serviceId/:poolId',
          name: 'Application',
          component: () => import('../views/smart/application.vue'),
          meta: { title: 'Application' }
        },
        {
          path: 'smart/result',
          name: 'SmartResult',
          component: () => import('../views/smart/result.vue'),
          meta: { title: 'Smart Result' }
        },
        {
          path: 'manage/cluster',
          name: 'Cluster',
          component: () => import('../views/kafkaManage/cluster.vue'),
          meta: { title: 'Kafka Manage Cluster' }
        },
        {
          path: 'manage/cluster/describe/:id',
          name: 'KafkaDescribe',
          component: () => import('../views/kafkaManage/describe.vue'),
          meta: { title: 'Kafka Manage Describe' },
          children: [
            {
              path: 'topic',
              name: 'Topic Describe',
              component: () => import('../views/kafkaManage/topicDescribe.vue'),
              meta: { title: 'Kafka Manage Topic Describe' }
            },
            {
              path: 'group',
              name: 'Group Describe',
              component: () => import('../views/kafkaManage/groupDescribe.vue'),
              meta: { title: 'Kafka Manage Group Describe' }
            }
          ]
        },
        {
          path: 'manage/dashboard',
          name: 'Dashboard',
          component: () => import('../views/cubeMonitor/index.vue'),
          meta: { title: 'Kafka Manage Dashboard' }
        },
        {
          path: 'manage/dashboard/:id/card',
          name: 'Dashboard',
          component: () => import('../views/cubeMonitor/card.vue'),
          meta: { title: 'Kafka Manage Dashboard Card' }
        },
        {
          path: 'manage/dashboard/card/edit/:cardId',
          name: 'Dashboard',
          component: () => import('../views/cubeMonitor/card.vue'),
          meta: { title: 'Edit Kafka Manage Dashboard Card' }
        },
        {
          path: 'manage/generate/:channelId',
          name: 'GenerateDashboard',
          component: () => import('../views/cubeMonitor/generate.vue'),
          meta: { title: 'Kafka Manage Generate Dashboard' }
        },
        {
          path: 'manage/generate/:channelId/:topicUrl',
          name: 'GenerateDashboard',
          component: () => import('../views/cubeMonitor/generate.vue'),
          meta: { title: 'Kafka Manage Generate Dashboard' }
        },
        {
          path: 'manage/alert',
          name: 'Alert',
          component: () => import('../views/manage/alert.vue'),
          meta: { title: 'Kafka Manage Alert' }
        },
        {
          path: 'manage/reassign',
          name: 'Reassign',
          component: () => import('../views/manage/reassign.vue'),
          meta: { title: 'Kafka Manage Reassign' }
        },
        {
          path: 'manage/webhook',
          name: 'Webhook',
          component: () => import('../views/manage/webhook.vue'),
          meta: { title: 'Kafka Manage Webhook' }
        },
        {
          path: 'manage/cube',
          name: 'CubeMonitor',
          component: () => import('../views/manage/cubeMonitor.vue'),
          meta: { title: 'Kafka Manage CubeMonitor' }
        },
        {
          path: 'permission',
          name: 'permission',
          redirect: '/dashboard/permission/menu',
          component: () => import('../views/statement/index.vue'),
          meta: { title: 'Permission Management' },
          children: [
            {
              path: 'menu',
              name: 'menu',
              component: () => import('../views/statement/menu.vue'),
              meta: { title: 'menu' }
            },
            {
              path: 'statement',
              name: 'statement',
              component: () => import('../views/statement/statement.vue'),
              meta: { title: 'statement' }
            }
          ]
        }
      ]
    },
    // {
    //   path: '/topic',
    //   component: Layout,
    //   name: 'topic',
    //   redirect: '/topic/index',
    //   meta: { title: 'Topic' },
    //   children: [
    //     {
    //       path: 'index',
    //       name: 'Topic',
    //       component: () => import('../views/topic/index.vue'),
    //       meta: { title: 'Topic' }
    //     },
    //     {
    //       path: 'info',
    //       name: 'Topic',
    //       component: () => import('../views/topic/topicDetail.vue'),
    //       meta: { title: 'Topic' }
    //     }
    //   ]
    // },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/login/index.vue')
    }
  ]
})
